import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { CardFeedResponse } from 'src/queries/cardFeeds/cardFeeds.models'
import { fetchCardFeed } from 'src/queries/cardFeeds/network/cardFeeds.network'
import {
  cardFeedsQueryKeys,
  queryCacheOptions,
} from 'src/queries/queries.constants'

const useQueryCardFeed = (
  organizationId: string | undefined,
  cardFeedId: string | undefined,
  enabled = true,
): UseQueryResult<CardFeedResponse> =>
  useQuery({
    queryKey: cardFeedsQueryKeys.detail(organizationId, cardFeedId),
    queryFn: async (): Promise<CardFeedResponse> =>
      fetchCardFeed(organizationId as string, cardFeedId as string),
    enabled:
      enabled && organizationId !== undefined && cardFeedId !== undefined,
    // Don't retry: a 404 should redirect to create and other errors should
    // show the error state immediately, not after several retry backoffs.
    retry: false,
    ...queryCacheOptions(),
  })

export default useQueryCardFeed
